import Swiper from 'swiper'
import 'swiper/css'

export class IndexOtherSlider {
  constructor() {
    if (document.getElementById('js-index_link_slider') === null) return
    if (window.innerWidth >= 768) return
    const otherSlider = new Swiper('#js-index_link_slider', {
      slidesPerView: 1.5,
      spaceBetween: 15,
      loop: false,
    })
  }
}
